module.exports = __webpack_public_path__ + "static/media/facebook.5ac58a41.png";